import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getMaintenanceCompanyList as getMaintenanceCompanyListApi,
	getMaintenanceCompany as getMaintenanceCompanyApi,
	addNewMaintenanceCompany as addNewMaintenanceCompanyApi,
	updateMaintenanceCompany as updateMaintenanceCompanyApi,
	deleteMaintenanceCompany as deleteMaintenanceCompanyApi,
} from '../../helpers/establishment/backend_helper';

export const getMaintenanceCompanyList = createAsyncThunk('holdings/getMaintenanceCompanyList', async () => {
	try {
		const response = getMaintenanceCompanyListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getMaintenanceCompany = createAsyncThunk('holdings/getMaintenanceCompany', async holding_id => {
	try {
		const response = getMaintenanceCompanyApi(holding_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewMaintenanceCompany = createAsyncThunk('holdings/addNewMaintenanceCompany', async holding => {
	try {
		const response = addNewMaintenanceCompanyApi(holding);
		toast.success('Empresa de Mantenimiento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar holding.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateMaintenanceCompany = createAsyncThunk('holdings/updateMaintenanceCompany', async (holding) => {
		try {
			const response = updateMaintenanceCompanyApi(holding);
			toast.success('Empresa de Mantenimiento actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar holding.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteMaintenanceCompany = createAsyncThunk('holdings/deleteMaintenanceCompany', async holding => {
	try {
		const response = await deleteMaintenanceCompanyApi(holding);
		toast.success('Empresa de Mantenimiento eliminado exitosamente.', { autoClose: 3000 });
		return { holding, ...response };
	} catch (error) {
		toast.error('Error al eliminar holding.', { autoClose: 3000 });
		throw new Error(error);
	}
});
